export default (value) =>
  !value
    ? value
    : value
        .replace(/[^0-9.]/g, '')
        .replace(/(\..*)\./g, '$1')
        .trim();
